import { Card, CardBody, CardFooter, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DarkColorCards, DarkColorText1, FooterCard, Smarteadphones } from "../../../../Constant";
import { DARK_COLOR_CARD } from "../../../../Data/Bonus Ui/BasicCard";
import { H6, Image, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";

const DarkColorCard = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={DarkColorCards} span={DARK_COLOR_CARD} className="bg-dark" headerClass={true} titleClass={true} />
        <CardBody className="bg-dark">
          <div className="d-flex align-items-center gap-3 pills-blogger">
            <div className="blog-wrapper"><Image className="blog-img" src={dynamicImage("dashboard-2/headphones.png")} alt="head-phone" /></div>
            <div className="blog-content">
              <P><em className="txt-danger fw-bold">{Smarteadphones}</em>{DarkColorText1}</P>
            </div>
          </div>
        </CardBody>
        <CardFooter className="bg-dark"><H6 className="mb-0">{FooterCard}</H6></CardFooter>
      </Card>
    </Col>
  );
};

export default DarkColorCard;
